import { getAuthToken, removeAuthToken } from "../helper/token";
import { expiredTokenHandler } from "../../redux/slices/auth-slice";
import HttpError from "../helper/HttpError";

export const getApi = async ({ apiUrl, sendToken = false, dispatch }) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (sendToken) {
    headers["x-access-token"] = getAuthToken();
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${apiUrl}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        dispatch(expiredTokenHandler());
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};

export const  postApi = async ({
  apiUrl,
  sendToken = false,
  dispatch,
  data = {},
}) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (sendToken) {
    headers["x-access-token"] = getAuthToken();
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${apiUrl}`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const { message , error } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        dispatch(expiredTokenHandler());
        throw new HttpError(401, message  || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || error || "something went wrong");
      }
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};

export const putApi = async ({
  apiUrl,
  sendToken = false,
  dispatch,
  data = {},
}) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (sendToken) {
    headers["x-access-token"] = getAuthToken();
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${apiUrl}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        dispatch(expiredTokenHandler());
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};

export const deleteApi = async ({
  apiUrl,
  sendToken = false,
  dispatch,
  data = {},
}) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (sendToken) {
    headers["x-access-token"] = getAuthToken();
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${apiUrl}`, {
      method: "DELETE",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        dispatch(expiredTokenHandler());
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
    return await response.json();
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};
